import React from "react";
import { Avatar, Box } from "@mui/material";
import Company from "../../types/company";
import theme from "../../theme";

interface Props {
  company: Company;
  size?: string;
}

const CompanyLogo: React.FC<Props> = (props) => {
  const { company, size } = props;

  return (
    <Box
      display="flex"
      flexDirection="row"
      sx={{
        flexShrink: 0,
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Avatar
        sx={{
          backgroundColor: theme.palette.background.default,
          width: size || "150px",
          height: size || "150px",
          color: "#fff",
        }}
      >
        <Box
          component="img"
          height={size || "150px"}
          width="100%"
          sx={{ objectFit: "cover" }}
          src={company.settings?.reportLogo?.url || "/static/images/SVPro.png"}
          alt={company.settings?.companyName}
        />
      </Avatar>
    </Box>
  );
};

export default CompanyLogo;
